import { CheckOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Space, Tooltip } from 'antd';
import { Link } from 'react-router-dom';

import type { ModelPaymentAccount } from '@app/api/PaymentAccounts';
import {
  ACQUIRING,
  ACQUIRING_LABEL,
  BANK,
  BANK_LABEL,
  CASH,
  CASH_LABEL,
  IS_DELETED,
  PAYMENTS_ACCOUNTS_PATH,
  U_ACTION,
  U_BALANCE,
  U_DESCRIPTION,
  U_IS_DEFAULT,
  U_KEY,
  U_LEGAL_ENTITY,
  U_NAME,
  U_PAY_TYPE,
} from '@app/constants';
import { divideAmount } from '@app/utils';

export const adaptDataToTable = (
  data: ModelPaymentAccount[],
  handleEdit: (id: number) => void,
  hasUserRightToEditPaymentsAccount: boolean
) => {
  return data.map((legalEntities) => {
    const {
      Id,
      Name,
      Description,
      IsDeleted,
      LegalEntity,
      PayType,
      Balance,
      IsDefault,
    } = legalEntities;

    const getPayTypeLabel = (type: string | null) => {
      switch (type) {
        case CASH:
          return CASH_LABEL;
        case BANK:
          return BANK_LABEL;
        case ACQUIRING:
          return ACQUIRING_LABEL;
        default:
          return '';
      }
    };

    return {
      [U_KEY]: String(Id),
      [U_NAME]: (
        <>
          {IsDeleted ? (
            <div style={{ opacity: '50%' }} data-testid="name-payment-account">
              {Name}
              <span
                style={{ color: 'red' }}
                data-testid="archive-payment-account"
              >
                <br />В архиве
              </span>
            </div>
          ) : (
            <Link
              to={`${PAYMENTS_ACCOUNTS_PATH}/edit/?id=${Id}`}
              data-testid="name-payment-account"
            >
              {Name}
            </Link>
          )}
        </>
      ),
      [U_IS_DEFAULT]: (
        <div style={{ opacity: IsDeleted ? '50%' : 100 }}>
          {IsDefault && (
            <Tooltip title="Касса по умолчанию. Эта касса отображается первой в списке при оплате услуг и товаров.">
              <CheckOutlined
                style={{ color: '#1677ff', cursor: 'pointer' }}
                data-testid="default-payment-account-icon"
              />
            </Tooltip>
          )}
        </div>
      ),
      [U_LEGAL_ENTITY]: (
        <div
          style={{ opacity: IsDeleted ? '50%' : 100 }}
          data-testid="legal-entity"
        >
          {LegalEntity}
        </div>
      ),
      [U_PAY_TYPE]: (
        <div
          style={{ opacity: IsDeleted ? '50%' : 100 }}
          data-testid="payment-method"
        >
          {getPayTypeLabel(PayType)}
        </div>
      ),
      [U_DESCRIPTION]: (
        <div
          style={{ opacity: IsDeleted ? '50%' : 100, minWidth: '170px' }}
          data-testid="note"
        >
          {Description}
        </div>
      ),
      [U_BALANCE]: (
        <div
          style={{ opacity: IsDeleted ? '50%' : 100, minWidth: '110px' }}
          data-testid="balance"
        >
          {divideAmount(Balance)}
        </div>
      ),
      [U_ACTION]: (
        <>
          {IsDeleted || !hasUserRightToEditPaymentsAccount ? (
            ''
          ) : (
            <Space style={{ opacity: IsDeleted ? '50%' : 100 }}>
              <Tooltip title="Редактировать">
                <Button
                  icon={<EditOutlined />}
                  onClick={() => handleEdit(Id)}
                  data-testid="edit-payment-account"
                />
              </Tooltip>
            </Space>
          )}
        </>
      ),
      [IS_DELETED]: IsDeleted,
    };
  });
};
